import type {
	OrderTimelineResponseDto,
	PartnerGeneralResponseDto,
} from "Infrastructure/Api/Api";

export type PartnerAllocationSource = "auto_offer" | "manual" | "reallocation";

export type PartnerAllocationHistoryItem = {
	id: number;
	orderId: number;
	partnerId: number;
	partner?: PartnerGeneralResponseDto | null;
	assignedAt: string;
	unassignedAt: string | null;
	source: PartnerAllocationSource;
	reason?: string | null;
	isCurrent?: boolean;
};

export function isPartnerAllocationTimelineRecord(
	item: OrderTimelineResponseDto,
) {
	return item.key === "partnerId";
}
